import { PipeTransform } from '@angular/core';
import { format, isDate, isValid } from 'date-fns';
var DateFnsPipe = /** @class */ (function () {
    function DateFnsPipe() {
    }
    DateFnsPipe.prototype.transform = function (value, formatStr) {
        if (value == null || value === '') {
            return '';
        }
        var dateval = null;
        dateval = (isDate(value) ? value : new Date(value));
        if (!isValid(dateval)) {
            return value;
        }
        return (formatStr ? format(dateval, formatStr) : dateval.toDateString());
    };
    return DateFnsPipe;
}());
export { DateFnsPipe };
